import { useMemo } from 'react';
import {
  Alert as BaseAlert,
  AlertProps as BaseAlertProps,
  Button,
} from '@mui/material';

import { useInlineAlertStyles } from './useInlineAlertStyles';

export interface IInlineAlertProps extends BaseAlertProps {
  className?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export function InlineAlert({
  className,
  buttonText,
  onButtonClick,
  children,
  ...rest
}: IInlineAlertProps) {
  const { classes, cx } = useInlineAlertStyles();

  const button = useMemo(() => {
    const shouldRenderButton =
      buttonText && typeof onButtonClick === 'function';

    if (!shouldRenderButton) return null;

    return (
      <Button size="small" onClick={onButtonClick}>
        {buttonText}
      </Button>
    );
  }, [onButtonClick, buttonText]);

  return (
    <BaseAlert {...rest} className={cx(classes.centralizedItems, className)}>
      <div className={classes.root}>
        <div className={classes.childrenRoot}>{children}</div>
        {button}
      </div>
    </BaseAlert>
  );
}
